import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VersionUpdateComponent } from './components/version-update/version-update.component';
import { TranslateModule } from '@ngx-translate/core';
import { IonButton } from '@ionic/angular/standalone';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [VersionUpdateComponent],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    IonButton,
    FontAwesomeModule,
  ],
})
export class VersionUpdateModule {}
